// Global beta signup modal control. Any component can call openBetaModal()
// to pop the beta form; the single modal instance lives in App.js.
export const openBetaModal = () => window.dispatchEvent(new CustomEvent("payday:open-beta"));
